// About view: title, five paragraphs, and the desaturated portrait caption.

const ABOUT = {
	title: "I came to AI through nineteen years of shipping systems that had to work",
	portrait: "/portrait.jpg",
	portraitAlt: "Anjanava Biswas",
	paragraphs: [
		"My first decade was ERP and retail systems: Oracle implementations, merchandising, demand forecasting. Unglamorous work that teaches you something durable: technology is only interesting at the point it changes what a business can actually do. That framing has never left me.",
		"At Petco I spent eight years as an architect responsible for platforms rather than projects, which is where I learned that the hard part of a machine learning system is rarely the model. It is the ingestion, the review workflow, the failure path, the executive who has to sign off on a decision made partly by software.",
		"Five years at AWS put me in front of hundreds of enterprises attempting the same transition at once. I saw which generative AI projects reached production and which quietly stopped at the demo. The difference was almost never model quality. It was whether anyone had designed for the case where the system is confidently wrong.",
		"So that is what I work on now: evaluation, red teaming, guardrails, policy enforcement: the architecture that makes agentic systems safe enough to be allowed to act. I write about it because writing forces precision, and I keep building because architecture divorced from implementation goes stale within a year.",
		"I read papers, I contribute to open source, and I still enjoy the moment a pipeline finally holds under load.",
	],
};

const NOT_FOUND = {
	title: "That page is not here",
	paragraphs: [
		"The address you followed does not match anything on this site. It may have been part of the previous version, which collapsed into five views: home, practice, publications, recognition, and about.",
		"Everything worth reading is one of those five. Start from the beginning, or use the navigation above.",
	],
};

export { ABOUT, NOT_FOUND };
